import {DeepLinkActionDescriptor, IDeepLinkParser} from '../deep-link-parser.interface';
import {Check} from '@sparkware/app-utils';
import {IDeepLinkBuilder} from '../../../deep-link-builders/deep-link-builder.interface';
import {DeepLinkJsonObjectBuilder} from '../../../deep-link-builders/deeplink-json-object-builder/deeplink-json-object-builder';



export class DeepLinkJsonObjectParser implements IDeepLinkParser {

  constructor(public deepLinkObject: any) {

  }


  getActionsDescriptors(): DeepLinkActionDescriptor[] {

    let marketingParams = {
      dl: this.deepLinkObject.dl,
      wtc: this.deepLinkObject.wtc
    };

    const promoCode = this.deepLinkObject.promoCode;


    let result: DeepLinkActionDescriptor[] = [];

    result.push({
      action: this.deepLinkObject.action,
      marketingParams: marketingParams,
      promoCode: promoCode,
      actionParams: {
        id: this.deepLinkObject.id
      }
    });

    for(let i = 0; i <= 2; i++) {
      let actionNextPropName = i === 0 ? 'action_next' : 'action_next' + i;
      let idNextPropName = i === 0 ? 'id_next' : 'id_next' + i;

      if(!Check.isNullOrUndefined(this.deepLinkObject[actionNextPropName])) {
        let params = {
          id: this.deepLinkObject[idNextPropName],
        };

        result.push({
          action: this.deepLinkObject[actionNextPropName],
          marketingParams: marketingParams,
          promoCode: promoCode,
          actionParams: params
        });
      }
    }

    return result;
  }


  getDeepLinkBuilder(): IDeepLinkBuilder {
    return new DeepLinkJsonObjectBuilder();
  }

}
